import { useEffect, useRef, useState } from 'react';
import { ReportFormatNumber } from '../../../../../func/Function';
import { DataProps } from './data';
import { s } from './ResultReport.styles';
import styled from 'styled-components';
import { usePatternContext } from '../../../../../context/PatternContext';

interface Props {
  data: DataProps[];
}

const ResultDetail = ({ data }: Props) => {
  const [showTooltip1, setShowTooltip1] = useState(false);
  const [showTooltip2, setShowTooltip2] = useState(false);
  const MyPatternData = data && data[1];
  const NationalData = data && data[3];
  const { patternInfo } = usePatternContext();
  const isSale = patternInfo.analysis_type === 'A';
  const [openAlgorithm, setOpenAlgorithm] = useState(true);
  const [openSafe, setOpenSafe] = useState(true);
  const [openPossibility, setOpenPossibility] = useState(true);
  const [openProfit, setOpenProfit] = useState(true);
  const [isFixed, setIsFixed] = useState(false);
  const FormatTotalResultText = (grade: number) => {
    if (grade === 1) {
      return <span style={{ color: '#F45551' }}>요주의</span>;
    } else if (grade === 2) {
      return <span style={{ color: '#09AB49' }}>보통</span>;
    } else if (grade === 3) {
      return <span style={{ color: '#008AFF' }}>우수</span>;
    } else {
      return <span style={{ color: '#008AFF' }}>매우우수</span>;
    }
  };

  const FormatText = (grade: number) => {
    if (grade === 1) {
      return <span style={{ color: '#F45551' }}>매우낮음</span>;
    } else if (grade === 2) {
      return <span style={{ color: '#F45551' }}>낮음</span>;
    } else if (grade === 3) {
      return <span style={{ color: '#3ECC80' }}>보통</span>;
    } else if (grade === 4) {
      return <span style={{ color: '#FF9524' }}>높음</span>;
    } else {
      return <span style={{ color: '#FF9524' }}>매우높음</span>;
    }
  };

  const Tooltip = (text: string, setShowTooltip: (value: boolean) => void) => {
    return (
      <div
        style={{
          position: 'absolute',
          top: 31,
          left: 0,
          width: 296,
          padding: '16px',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontSize: 14,
          fontWeight: 500,
          color: '#222',
          boxShadow:
            '0px 6px 12px 0px rgba(0, 0, 0, 0.12), 0px 4px 8px 0px rgba(0, 0, 0, 0.08), 0px 0px 4px 0px rgba(0, 0, 0, 0.08)',
          borderRadius: 8,
          backgroundColor: '#fff',
          zIndex: 100,
        }}
      >
        <span>{text}</span>
        <img
          src="/assets/images/close/close-dark-gray.svg"
          alt="툴팁 닫기"
          onClick={() => {
            setShowTooltip(false);
          }}
          style={{ cursor: 'pointer' }}
        />
      </div>
    );
  };
  const typeRef = useRef<HTMLDivElement>(null);
  const typeEndRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const typeTop = typeRef.current?.offsetTop || 0;
    const typeEnd = typeEndRef.current?.offsetTop || 0;
    if (typeTop == null || typeEnd == null) {
      setIsFixed(false);
      return;
    }
    const scroll = () => {
      if (window.scrollY > typeTop && window.scrollY < typeEnd) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };
    window.addEventListener('scroll', scroll);
    scroll(); // mount 즉시 실행
    return () => {
      window.removeEventListener('scroll', scroll);
    };
  }, []);

  return (
    <Container>
      <TitleBox ref={typeRef}>
        <div style={{ fontSize: '16px', fontWeight: 700 }}>
          알고리즘 상세분석 결과
        </div>
        <s.Tag grade={MyPatternData.grade}>
          {FormatTotalResultText(MyPatternData.grade)}
        </s.Tag>
      </TitleBox>
      <TypeBox isFixed={isFixed}>
        <div>내 알고리즘</div>
        <div>전국</div>
      </TypeBox>
      <Inner>
        <ContentWrapper>
          <ContentTitle isOpen={openAlgorithm}>
            <div>알고리즘 분석 범위</div>
            <img
              onClick={() => {
                setOpenAlgorithm(!openAlgorithm);
              }}
              src={`/assets/images/arrow/${openAlgorithm ? 'arrow-up-989ba2' : 'arrow-down-989ba2'}.svg`}
              alt=""
              style={{ width: '16px', height: '16px' }}
            />
          </ContentTitle>
          <ContentBox isOpen={openAlgorithm}>
            <ContentDescription>
              <span>전체 경매 건수</span>
            </ContentDescription>
            <ContentNumber>
              <div> {Number(MyPatternData.total_cnt).toLocaleString()} 건</div>
              <div>{Number(NationalData.total_cnt).toLocaleString()} 건</div>
            </ContentNumber>
            <ContentDescription>
              <span>수익(Win)물건 수</span>
            </ContentDescription>
            <ContentNumber>
              <div>{Number(MyPatternData.success_cnt).toLocaleString()} 건</div>
              <div>{Number(NationalData.success_cnt).toLocaleString()} 건</div>
            </ContentNumber>
          </ContentBox>
        </ContentWrapper>
        <ContentWrapper>
          <ContentTitle isOpen={openSafe}>
            <div>
              <div>안정성</div>
              <div>{FormatText(MyPatternData.safety)}</div>
            </div>
            <img
              onClick={() => {
                setOpenSafe(!openSafe);
              }}
              src={`/assets/images/arrow/${openSafe ? 'arrow-up-989ba2' : 'arrow-down-989ba2'}.svg`}
              alt=""
              style={{ width: '16px', height: '16px' }}
            />
          </ContentTitle>
          <ContentBox isOpen={openSafe}>
            <ContentDescription>
              <span>승률</span>
            </ContentDescription>
            <ContentNumber>
              <div>
                {' '}
                {ReportFormatNumber(MyPatternData.success, true, true)}
              </div>
              <div> {ReportFormatNumber(NationalData.success, true, true)}</div>
            </ContentNumber>
            <ContentDescription>
              <span>수익(Win)물건 수</span>
            </ContentDescription>
            <ContentNumber>
              <div>
                {' '}
                {ReportFormatNumber(MyPatternData.failure, true, true)}
              </div>
              <div> {ReportFormatNumber(NationalData.failure, true, true)}</div>
            </ContentNumber>
          </ContentBox>
        </ContentWrapper>
        <ContentWrapper>
          <ContentTitle isOpen={openPossibility}>
            <div>
              <div>
                {isSale ? '시세차익가능성' : '총투자비 대비 연간 임대수익률'}
              </div>
              <div>{FormatText(MyPatternData.profit_possibility)}</div>
            </div>
            <img
              onClick={() => {
                setOpenPossibility(!openPossibility);
              }}
              src={`/assets/images/arrow/${openPossibility ? 'arrow-up-989ba2' : 'arrow-down-989ba2'}.svg`}
              alt=""
              style={{ width: '16px', height: '16px' }}
            />
          </ContentTitle>
          <ContentBox isOpen={openPossibility}>
            <ContentDescription>
              <span>시세 대비 감정가 수준</span>
            </ContentDescription>
            <ContentNumber>
              <div>
                {ReportFormatNumber(
                  MyPatternData.appraisal_market_rate,
                  true,
                  true,
                )}
              </div>
              <div>
                {ReportFormatNumber(
                  NationalData.appraisal_market_rate,
                  true,
                  true,
                )}
              </div>
            </ContentNumber>
            <ContentDescription>
              <span>감정가 대비 낙찰가율</span>
            </ContentDescription>
            <ContentNumber>
              <div>
                {ReportFormatNumber(
                  MyPatternData.auction_appraisal_rate,
                  true,
                  true,
                )}
              </div>
              <div>
                {ReportFormatNumber(
                  NationalData.auction_appraisal_rate,
                  true,
                  true,
                )}
              </div>
            </ContentNumber>
            <ContentDescription>
              <span>시세 대비 낙찰가율</span>
            </ContentDescription>
            <ContentNumber>
              <div>
                {ReportFormatNumber(
                  MyPatternData.auction_market_rate,
                  true,
                  true,
                )}
              </div>
              <div>
                {ReportFormatNumber(
                  NationalData.auction_market_rate,
                  true,
                  true,
                )}
              </div>
            </ContentNumber>
            <ContentDescription>
              <span>낙찰가 평균</span>
              <ExtraInfoBox>보조지표</ExtraInfoBox>
            </ContentDescription>
            <ContentNumber>
              <div>{ReportFormatNumber(Number(MyPatternData.auction_prc))}</div>
              <div>{ReportFormatNumber(Number(NationalData.auction_prc))}</div>
            </ContentNumber>
            {isSale && (
              <ContentDescription>
                <span>매각가 평균</span>
                <ExtraInfoBox>보조지표</ExtraInfoBox>
              </ContentDescription>
            )}
            {isSale && (
              <ContentNumber>
                <div>
                  {ReportFormatNumber(Number(MyPatternData.transaction_prc))}
                </div>
                <div>
                  {ReportFormatNumber(Number(NationalData.transaction_prc))}
                </div>
              </ContentNumber>
            )}
            {isSale && (
              <ContentDescription>
                <span>매각차익률</span>
                <ExtraInfoBox>보조지표</ExtraInfoBox>
              </ContentDescription>
            )}
            {isSale && (
              <ContentNumber>
                <div>
                  {ReportFormatNumber(
                    MyPatternData.sale_profit_rate,
                    true,
                    true,
                  )}
                </div>
                <div>
                  {ReportFormatNumber(
                    NationalData.sale_profit_rate,
                    true,
                    true,
                  )}
                </div>
              </ContentNumber>
            )}
          </ContentBox>
        </ContentWrapper>
        <ContentWrapper>
          <ContentTitle isOpen={openProfit}>
            <div>
              <div>수익성</div>
              <div>{FormatText(MyPatternData.profitability)}</div>
            </div>
            <img
              onClick={() => {
                setOpenProfit(!openProfit);
              }}
              src={`/assets/images/arrow/${openProfit ? 'arrow-up-989ba2' : 'arrow-down-989ba2'}.svg`}
              alt=""
              style={{ width: '16px', height: '16px' }}
            />
          </ContentTitle>
          <ContentBox isOpen={openProfit}>
            <ContentDescription>
              <span>실투금 평균</span>
              <img
                src="/assets/images/icon/info-16.svg"
                alt=""
                onClick={() => {
                  setShowTooltip1(!showTooltip1);
                }}
                style={{ cursor: 'pointer' }}
              />
              {showTooltip1 && Tooltip('실제투자금액', setShowTooltip1)}
            </ContentDescription>
            <ContentNumber>
              <div>{ReportFormatNumber(Number(MyPatternData.capital))}</div>
              <div>{ReportFormatNumber(Number(NationalData.capital))}</div>
            </ContentNumber>
            <ContentDescription>
              <span>{isSale ? '세후이익 평균' : '연간 임대수익 평균'}</span>
            </ContentDescription>
            <ContentNumber>
              <div>
                {ReportFormatNumber(Number(MyPatternData.after_tax_profit))}
              </div>
              <div>
                {ReportFormatNumber(Number(NationalData.after_tax_profit))}
              </div>
            </ContentNumber>
            {isSale && (
              <ContentDescription>
                <span>실투금 대비 매각수익률(ROI)</span>
                <ExtraInfoBox>보조지표</ExtraInfoBox>
              </ContentDescription>
            )}
            {isSale && (
              <ContentNumber>
                <div>
                  {ReportFormatNumber(
                    Number(MyPatternData.capital_profit_rate),
                    true,
                    true,
                  )}
                </div>
                <div>
                  {ReportFormatNumber(
                    Number(NationalData.capital_profit_rate),
                    true,
                    true,
                  )}
                </div>
              </ContentNumber>
            )}
            <ContentDescription>
              <span>낙찰가 평균</span>
              <ExtraInfoBox>보조지표</ExtraInfoBox>
            </ContentDescription>
            <ContentNumber>
              <div>{ReportFormatNumber(Number(MyPatternData.auction_prc))}</div>
              <div>{ReportFormatNumber(Number(NationalData.auction_prc))}</div>
            </ContentNumber>
            <ContentDescription>
              <span>선투입비 평균</span>{' '}
              <img
                src="/assets/images/icon/info-16.svg"
                alt=""
                onClick={() => {
                  setShowTooltip2(!showTooltip2);
                }}
              />
              {showTooltip2 &&
                Tooltip('실제투자금액 + 대출금', setShowTooltip2)}
              <ExtraInfoBox>보조지표</ExtraInfoBox>
            </ContentDescription>
            <ContentNumber>
              <div>
                {ReportFormatNumber(Number(MyPatternData.upfront_costs))}
              </div>
              <div>
                {ReportFormatNumber(Number(NationalData.upfront_costs))}
              </div>
            </ContentNumber>
            <ContentDescription ref={typeEndRef}>
              <span>
                {isSale
                  ? '선투입비 대비 매각수익률(ROE)'
                  : '총투자비 대비 연간 임대수익률 (ROI)'}
              </span>
            </ContentDescription>
            <ContentNumber>
              <div>
                {ReportFormatNumber(
                  Number(MyPatternData.upfront_profit_rate),
                  true,
                  true,
                )}
              </div>
              <div>
                {ReportFormatNumber(
                  Number(NationalData.upfront_profit_rate),
                  true,
                  true,
                )}
              </div>
            </ContentNumber>
            <ContentDescription>
              <span>
                {isSale
                  ? '낙찰가 대비 매각수익률'
                  : '자기자본 대비 연간 임대수익률 (ROE)'}
              </span>
            </ContentDescription>
            <ContentNumber>
              <div>
                {ReportFormatNumber(
                  Number(MyPatternData.auction_profit_rate),
                  true,
                  true,
                )}
              </div>
              <div>
                {ReportFormatNumber(
                  Number(NationalData.auction_profit_rate),
                  true,
                  true,
                )}
              </div>
            </ContentNumber>
          </ContentBox>
        </ContentWrapper>
      </Inner>
    </Container>
  );
};

export default ResultDetail;

const ExtraInfoBox = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0px 4px;
  border-radius: 4px;
  background: rgba(112, 115, 124, 0.08);
  color: rgba(55, 56, 60, 0.61);
  font-size: 12px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 17.4px;
  word-wrap: break-word;
`;

const ContentNumber = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  div {
    width: 50%;
    text-align: center;
  }
`;

const ContentDescription = styled.div`
  width: 100%;
  display: flex;
  border-radius: 4px;
  background: #fafafb;
  padding: 9px 16px;
  flex-direction: row;
  gap: 4px;
  position: relative;
`;

interface ContentBoxProps {
  isOpen: boolean;
}

const ContentBox = styled.div<ContentBoxProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  color: #222222;
  font-size: 13px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 18.85px;
  word-wrap: break-word;
  span {
    color: #616161;
    font-size: 13px;
    font-weight: 500;
  }
  display: ${(props) => (props.isOpen ? 'flex' : 'none')};
`;

const ContentTitle = styled.div<ContentBoxProps>`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #222222;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 20.3px;
  word-wrap: break-word;
  padding: 8px 0px;
  border-bottom: ${(props) => (props.isOpen ? '1px solid #e5e8ea' : 'none')};
  div {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }
`;
const ContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background-color: #fff;
`;

const Inner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: #f7f8fc;
`;

interface TypeBoxProps {
  isFixed: boolean;
}

const TypeBox = styled.div<TypeBoxProps>`
  width: 100%;
  max-width: 900px;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #222222;
  font-size: 16px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 23.2px;
  word-wrap: break-word;
  padding: 16px;
  position: ${(props) => (props.isFixed ? 'fixed' : 'static')};

  background-color: #fff;
  z-index: 10;
  border-bottom: 1px solid #e5e8ea;
  top: 98px;

  div {
    width: 50%;
    text-align: center;
  }
`;

const TitleBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 24px 16px;
  gap: 8px;
  align-items: center;
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
`;
